import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'measures',
})
export class MeasuresPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(value: string | number = 0, precision: number, unit: string): string {
    value = (typeof value === 'number' && isNaN(value)) ? 0 : value;
    const formatValue = (Math.abs(typeof value === 'string' ? Number(value) : value)).toFixed(precision);
    if(!Number.isFinite(value)) {
      return `0${unit}`;
    }
    const onlyZeros = formatValue.match(/\.0+$/);
    if (onlyZeros) {
      return `${formatValue.replace(onlyZeros[0], '')} ${unit}`;
    }
    return `${(formatValue)} ${unit}`;
  }
}
